import { render, staticRenderFns } from "./WithDownloads.html?vue&type=template&id=ae7df984&"
import script from "./WithDownloads.ts?vue&type=script&lang=ts&"
export * from "./WithDownloads.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports